/**
 * REWE Digital GmbH.
 * IT-Verticals
 *
 * vx-paginator component
 */
:host {
  display: block;
  position: relative;
  z-index: 1;
}

.vx-paginator__wrapper {
  display: flex;
  justify-content: center;
}
.vx-paginator__wrapper,
.vx-paginator__wrapper button {
  color: var(--vx-pagination-text-color, var(--ci-neutral700, #5b5b5b));
}
.vx-paginator__wrapper button {
  border: none;
  background-color: transparent;
  margin: 0 2px;
}
.vx-paginator__wrapper button[disabled] {
  color: var(--vx-pagination-disabled-text-color, var(--ci-neutral500, #b2b2b2));
}
.vx-paginator__wrapper button:not([disabled]) {
  cursor: pointer;
}

.vx-paginator__btn-left {
  text-align: right;
}

.vx-paginator__btn-right {
  text-align: left;
}

.vx-paginator__dropdown {
  border-radius: 4px;
  border-color: var(--vx-pagination-border-color, var(--ci-neutral400, #d1d1d1));
  border-width: var(--vx-pagination-border-width, 1px);
  border-style: var(--vx-pagination-border-style, solid);
  color: inherit;
}

@media only screen and (min-width: 768px) {
  .vx-paginator__btn-left:not([disabled]):hover,
  .vx-paginator__btn-right:not([disabled]):hover {
    color: var(--ci-primary400);
  }
}